/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiListSelectorOption
 */
export interface InternalApiListSelectorOption {
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelectorOption
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelectorOption
     */
    fullValue: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiListSelectorOption
     */
    parentValue: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiListSelectorOption
     */
    descriptions: Array<string>;
}

/**
 * Check if a given object implements the InternalApiListSelectorOption interface.
 */
export function instanceOfInternalApiListSelectorOption(value: object): value is InternalApiListSelectorOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('fullValue' in value) || value['fullValue'] === undefined) return false;
    if (!('parentValue' in value) || value['parentValue'] === undefined) return false;
    if (!('descriptions' in value) || value['descriptions'] === undefined) return false;
    return true;
}

export function InternalApiListSelectorOptionFromJSON(json: any): InternalApiListSelectorOption {
    return InternalApiListSelectorOptionFromJSONTyped(json, false);
}

export function InternalApiListSelectorOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiListSelectorOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'fullValue': json['fullValue'],
        'parentValue': json['parentValue'],
        'descriptions': json['descriptions'],
    };
}

export function InternalApiListSelectorOptionToJSON(json: any): InternalApiListSelectorOption {
    return InternalApiListSelectorOptionToJSONTyped(json, false);
}

export function InternalApiListSelectorOptionToJSONTyped(value?: InternalApiListSelectorOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'fullValue': value['fullValue'],
        'parentValue': value['parentValue'],
        'descriptions': value['descriptions'],
    };
}

